import styled from '@emotion/styled';

export const Wrapper = styled.div`
	display: inline-block;
	line-height: 0;
	color: ${(props) => props.color};

	&.x-small {
		font-size: 1.29rem !important; // 12px
		${(props) => props.fontSize && `font-size: ${props.fontSize} !important;`}
	}
	&.small {
		font-size: 1.51rem !important; // 14px
		${(props) => props.fontSize && `font-size: ${props.fontSize} !important;`}
	}
	&.medium {
		font-size: 1.94rem !important; // 18px
		${(props) => props.fontSize && `font-size: ${props.fontSize} !important;`}
	}
	&.large {
		font-size: 2.37rem !important; // 22px
		${(props) => props.fontSize && `font-size: ${props.fontSize} !important;`}
	}
	&.x-large {
		font-size: 2.8rem !important; // 26px
		${(props) => props.fontSize && `font-size: ${props.fontSize} !important;`}
	}
	&.xx-large {
		font-size: 3.23rem !important; // 30px
		${(props) => props.fontSize && `font-size: ${props.fontSize} !important;`}
	}
	&.xxx-large {
		font-size: 3.66rem !important; // 34px
		${(props) => props.fontSize && `font-size: ${props.fontSize} !important;`}
	}

	> svg {
		transition: all 0.2s ease;
	}
`;
